const createEnum = (...values) => Object.freeze(values.reduce((obj, value) => {
    obj[value] = value
    return obj
  }, {}))

export default createEnum
